export const EVENTS = {
  ON_CLICK_BUTTON_CREATE: "onClickButtonCreate"
};
